import _asyncToGenerator from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator";
import crypto from './webcrypto.js';

var digest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(algorithm, data) {
    var subtleDigest;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            subtleDigest = "SHA-".concat(algorithm.slice(-3));
            _context.t0 = Uint8Array;
            _context.next = 4;
            return crypto.subtle.digest(subtleDigest, data);

          case 4:
            _context.t1 = _context.sent;
            return _context.abrupt("return", new _context.t0(_context.t1));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function digest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default digest;